"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetBaseBuilder = void 0;
var tslib_1 = require("tslib");
var builder_1 = require("../builder");
/**
 * @alpha
 */
var WidgetBaseBuilder = /** @class */ (function (_super) {
    tslib_1.__extends(WidgetBaseBuilder, _super);
    function WidgetBaseBuilder() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.setWidget = function (updateCallback) {
            _this.item = updateCallback(_this.item);
            return _this;
        };
        _this.setWidgetProp = function (prop, valueOrUpdateCallback) {
            _this.setWidget(function (w) {
                var _a;
                return (tslib_1.__assign(tslib_1.__assign({}, w), (_a = {}, _a[prop] = builder_1.resolveValueOrUpdateCallback(valueOrUpdateCallback, w[prop]), _a)));
            });
            return _this;
        };
        _this.title = function (valueOrUpdateCallback) {
            return _this.setWidgetProp("title", valueOrUpdateCallback);
        };
        _this.description = function (valueOrUpdateCallback) {
            return _this.setWidgetProp("description", valueOrUpdateCallback);
        };
        _this.ignoreDashboardFilters = function (valueOrUpdateCallback) { return _this.setWidgetProp("ignoreDashboardFilters", valueOrUpdateCallback); };
        _this.dateDataSet = function (valueOrUpdateCallback) {
            return _this.setWidgetProp("dateDataSet", valueOrUpdateCallback);
        };
        _this.ref = function (valueOrUpdateCallback) {
            return _this.setWidgetProp("ref", valueOrUpdateCallback);
        };
        _this.id = function (valueOrUpdateCallback) {
            return _this.setWidgetProp("identifier", valueOrUpdateCallback);
        };
        _this.uri = function (valueOrUpdateCallback) {
            return _this.setWidgetProp("uri", valueOrUpdateCallback);
        };
        return _this;
    }
    return WidgetBaseBuilder;
}(builder_1.Builder));
exports.WidgetBaseBuilder = WidgetBaseBuilder;
//# sourceMappingURL=widgetFactory.js.map